<div class="internal-user-card">
  <app-loading [hidden]="!(viewModel.isLoading$ | async)" [options]="(viewModel.loadingOpts$ | async) ?? undefined" />
  <ng-content></ng-content>
</div>
